import { render, staticRenderFns } from "./vGaleria.vue?vue&type=template&id=49a1657f&scoped=true"
import script from "./vGaleria.vue?vue&type=script&lang=js"
export * from "./vGaleria.vue?vue&type=script&lang=js"
import style0 from "./vGaleria.vue?vue&type=style&index=0&id=49a1657f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a1657f",
  null
  
)

export default component.exports